const getScrollbarWidth = () =>
  window.innerWidth - document.documentElement.clientWidth;

$(".product-sizes-wrapper").on('click', '.quick-view', function (e) {
  e.preventDefault();
  var product_handle = $(this).data('handle');
  var product_id = $(this).data('product-id');
  var base_product_id = $(this).data('base-product-id');
  var product_fit = $(this).data('product-fit');
  var colors = $('.quick--add__wrapper [data-product-id=' + base_product_id + ']').parent().parent().find('.colour-swatch-items').data('colors');
  var colorName = $('.quick--add__wrapper [data-product-id=' + base_product_id + ']').data('product-color-name');

  $('.quickview-product-images').empty();
  $('.quickview-colour-swatches').empty();
  $('#quickview-sizes').empty();
  $('.quickview-product-fit').empty();
  $('.final-sale').hide();
  $('#sizeDisplayQV').empty();

  if(colors) {
    colorOptions = colors.split(',');
  } else {
    colorOptions = false;
  }

  jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
    var title = product.title;
    var type = product.type;
    var price = 0;
    var original_price = 0;
    var images = product.images;
    var variants = product.variants;
    var final_sale = false;
    // var options = product.options;
    var url = '/products/' + product_handle;

    product.tags.forEach(tag => {
      if(tag == 'final-sale') {
        final_sale = true;
      }
    });

    if(type === 'Gift Cards') {
      console.log('here');
      $('#quickview').addClass('gift-card');
    } else {
      $('#quickview').removeClass('gift-card');
    }

    $('.product-detail-title').text(title);
    // $('.product-type').text(type);
    $('.view-product').attr('href', url);

    image_embed = '';
    $(images).each(function (i, image) {
      if(i > 0) {
        image_embed = image_embed + '<img src="' + image + '" width="800" height="600" loading="lazy">';
      }
    });

    $('.quickview-product-images').append(image_embed);

    if(colorOptions.length > 0) {
      if(colorOptions.length == 1) {
        $('#quickview .product-color-wrap').addClass('single-color');
      } else {
        $('#quickview .product-color-wrap').removeClass('single-color');
      }

      colorOptions.forEach(colorOption => {
        colorOptionsItems = colorOption.split(':');

        $('.product-color-wrap').removeClass('no-colors');

        if(product_handle == colorOptionsItems[3]) {
          if(colorOptionsItems[2] !== '') {
            $('.quickview-colour-swatches').append('<li class="colour-swatch-item is-current"><a class="quick-view quick-view-slim" href="#" data-handle="' + colorOptionsItems[3] + '" data-product-id="' + colorOptionsItems[4] + '" data-base-product-id="' + base_product_id + '" data-product-fit="' + product_fit + '"><span class="colour-swatch" data-color-name="' + colorOptionsItems[0] + '" name="' + colorOptionsItems[0] + '"><span class="colour-swatch-1" style="background-color:#' + colorOptionsItems[1] + '"></span><span class="colour-swatch-2" style="background-color:#' + colorOptionsItems[2] + '"></span></li>');
          } else {
            $('.quickview-colour-swatches').append('<li class="colour-swatch-item is-current"><a class="quick-view quick-view-slim" href="#" data-handle="' + colorOptionsItems[3] + '" data-product-id="' + colorOptionsItems[4] + '" data-base-product-id="' + base_product_id + '" data-product-fit="' + product_fit + '"><span class="colour-swatch" style="background-color:#' + colorOptionsItems[1] + '" data-color-name="' + colorOptionsItems[0] + '" name="' + colorOptionsItems[0] + '"></span></li>');
          }
          $('#quickViewColorDisplay').text(colorOptionsItems[0]);
        } else {
          if (colorOptionsItems[2] !== '') {
            $('.quickview-colour-swatches').append('<li class="colour-swatch-item"><a class="quick-view quick-view-slim" href="#" data-handle="' + colorOptionsItems[3] + '" data-product-id="' + colorOptionsItems[4] + '" data-base-product-id="' + base_product_id + '" data-product-fit="' + product_fit + '"><span class="colour-swatch" data-color-name="' + colorOptionsItems[0] + '" name="' + colorOptionsItems[0] + '"><span class="colour-swatch-1" style="background-color:#' + colorOptionsItems[1] + '"></span><span class="colour-swatch-2" style="background-color:#' + colorOptionsItems[2] + '"></span></span></li>');
          } else {
            $('.quickview-colour-swatches').append('<li class="colour-swatch-item"><a class="quick-view quick-view-slim" href="#" data-handle="' + colorOptionsItems[3] + '" data-product-id="' + colorOptionsItems[4] + '" data-base-product-id="' + base_product_id + '" data-product-fit="' + product_fit + '"><span class="colour-swatch" style="background-color:#' + colorOptionsItems[1] + '" data-color-name="' + colorOptionsItems[0] + '" name="' + colorOptionsItems[0] + '"></span></li>');
          }
        }
      });
    } else {
      if (colorName) {
        $('#quickViewColorDisplay').text(colorName);
        $('#quickview .product-color-wrap').addClass('single-color');
      } else {
        $('.product-color-wrap').addClass('no-colors');
      }
    }

    if(product_fit) {
      $('.quickview-product-fit').removeClass('no-fit');
      $('.quickview-product-fit').html('<div>Fit: <strong>' + product_fit + '</strong></div>');
    } else {
      $('.quickview-product-fit').addClass('no-fit');
    }

    $(variants).each(function (i, variant) {
      var size = variant['option1'];
      var short_size = '';

      if(size == 'Extra Small') {
        short_size = 'XS';
      } else if(size == 'Small') {
        short_size = 'S';
      } else if(size == 'Medium') {
        short_size = 'M';
      } else if(size == 'Extra Extra Large') {
        short_size = 'XXL';
      } else if(size == 'XX Large') {
        short_size = 'XXL';
      } else if(size == 'Extra Large') {
        short_size = 'XL';
      } else if(size == 'Large') {
        short_size = 'L';
      } else if(size == 'S/M') {
        short_size = 'S/M';
      } else if(size == 'L/XL') {
        short_size = 'L/XL';
      }

      if (variant['option1'] == 'O/S' || variant['option1'] == 'OS') {
        $('.product-size-wrap').addClass('one-size');
        $('#quickview-sizes').append('<label class="product-size-form__item is-available"><input checked type="radio" name="id" data-sku="' + variant.sku + '" value="' + variant.id + '" data-size="O/S" data-stock="' + variant.inventory_quantity + '" data-price="' + variant.price + '" data-compare-price="' + variant.compare_at_price + '"><span class="product-size">' + short_size + '</span></label>');

        if (variant['available']) {
          $('#sizeDisplayQV').text('O/S');
        } else {
          $('#sizeDisplayQV').text('O/S - SOLD OUT');
        }
      } else if (short_size != '') {
        $('.product-size-wrap').removeClass('one-size');
        if(variant['available']) {
          $('#quickview-sizes').append('<label class="product-size-form__item is-available"><input type="radio" name="id" data-sku="' + variant.sku + '" value="' + variant.id + '" data-size="' + short_size + '" data-stock="' + variant.inventory_quantity + '" data-price="' + variant.price + '" data-compare-price="' + variant.compare_at_price + '"><span class="product-size">' + short_size + '</span></label>');
        } else {
          $('#quickview-sizes').append('<label class="product-size-form__item"><input disabled type="radio" data-size="' + short_size + '" data-stock="' + variant.inventory_quantity + '"><span class="product-size product-size--not-available">' + short_size + '</span></label>');
        }
      } else {
        $('.product-size-wrap').removeClass('one-size');
        if (variant['available']) {
          $('#quickview-sizes').append('<label class="product-size-form__item is-available"><input type="radio" name="id" data-sku="' + variant.sku + '" value="' + variant.id + '" data-size="' + size + '" data-stock="' + variant.inventory_quantity + '" data-price="' + variant.price + '" data-compare-price="' + variant.compare_at_price + '"><span class="product-size">' + size + '</span></label>');
        } else {
          $('#quickview-sizes').append('<label class="product-size-form__item"><input disabled type="radio" data-size="' + size + '" data-stock="' + variant.inventory_quantity + '"><span class="product-size product-size--not-available">' + size + '</span></label>');
        }
      }
    });

    if(final_sale) {
      $('.final-sale').show();
    }

    $(product.variants).each(function (i, v) {
      if (v.inventory_quantity == 0) {
        return true
      } else {
        price = parseInt(v.price / 100).toFixed(2);
        original_price = parseInt(v.compare_at_price / 100).toFixed(2);

        if (product.price_max > product.price_min) {
          var price_max = parseInt(product.price_max / 100).toFixed(2);
          var price_min = parseInt(product.price_min / 100).toFixed(2);
          $('.pdp-price').text('$' + price_min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' - $' + price_max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ' + $('body').data('currency'));
        } else {
          $('.pdp-price').text('$' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ' + $('body').data('currency'));
        }

        if (original_price > 0) {
          $('.quickview-product-original-price').text('$' + original_price + ' ' + $('body').data('currency')).show();
        } else {
          $('.quickview-product-original-price').hide();
        }
        return false
      }
    });

    if(product.available) {
      $('.quick-view-outofstock').hide();
      $('#AddToCart').show();
    } else {
      $('.quick-view-outofstock').show();
      $('#AddToCart').hide();
    }
  });

  $('body').css('paddingRight', getScrollbarWidth() + 'px');
  $('body').addClass('quickview-enabled');

  setTimeout(function () {
    //your code to be executed after 1 second
    $('#quickview').addClass('active');
    // $('#quickview').addClass(product_handle);
  }, 300);
});

var $productSizeItem = $('#quickview-sizes'),
  $sizeDisplay = $('#sizeDisplayQV'),
  defaultSize,
  defaultStock,
  currentSizeItem,
  currentSize,
  currentStock;

if ($productSizeItem.find('input').length === 1 && $productSizeItem.find('input[disabled]').length === 1) {
  defaultSize = $productSizeItem.find('input[disabled]').data('size');
  defaultStock = $productSizeItem.find('input[disabled]').data('stock');
}
else {
  defaultSize = $productSizeItem.find('input:checked').data('size');
  defaultStock = $productSizeItem.find('input:checked').data('stock');
}

if (defaultSize !== undefined && defaultStock !== undefined) {
  // if (defaultStock > 5) {
  //   $sizeDisplay.html(defaultSize);
  // }
  // else {
  //   if (defaultStock > 0) {
  //     $sizeDisplay.html(defaultSize + ' - Only ' + defaultStock + ' Remaining');
  //   }
  //   else {
  //     $sizeDisplay.html(defaultSize + ' - Sold Out');
  //   }
  // }
  $sizeDisplay.html(defaultSize);
}

$productSizeItem.on('click', '.product-size-form__item', function () {
  currentSizeItem = $(this).find('input:checked');

  if (currentSizeItem.length) {
    currentSize = $(this).find('input').data('size');
    currentStock = $(this).find('input').data('stock');

    // if (currentStock > 5) {
    //   $sizeDisplay.html(currentSize);
    // }
    // else {
    //   if (currentStock > 0) {
    //     $sizeDisplay.html(currentSize + ' - Only ' + currentStock + ' Remaining');
    //   }
    //   else {
    //     $sizeDisplay.html(currentSize + ' - Sold Out');
    //   }
    // }
    $sizeDisplay.html(currentSize);

    if ($(this).hasClass('is-available')) {
      $('#AddToCart').removeClass('disabled').prop('disabled', false);
    }
  }

});

// Size Hover
$productSizeItem.on('mouseover', '.product-size-form__item', function () {
  currentSize = $(this).find('input').data('size');

  if($(this).hasClass('is-available')) {
    currentStock = 6;
  } else {
    currentStock = 0;
  }

  if (currentStock > 5) {
    $sizeDisplay.html(currentSize);
  }
  else {
    if (currentStock > 0) {
      $sizeDisplay.html(currentSize + ' - Only ' + currentStock + ' Remaining');
    }
    else {
      $sizeDisplay.html(currentSize + ' - Sold Out');
    }
  }
  // console.log(currentStock);
  // if (currentStock > 0) {
  //   console.log('here');
  //   $sizeDisplay.html(currentSize);
  // } else {
  //   console.log('there');
  //   $sizeDisplay.html(currentSize + ' - Sold Out');
  // }
});

$productSizeItem.on('mouseout', '.product-size-form__item', function () {
  currentSizeItem = $productSizeItem.find('input:checked');

  if (currentSizeItem.length) {

    currentSize = currentSizeItem.data('size');
    currentStock = currentSizeItem.data('stock');

    // if (currentStock > 5) {
    //   $sizeDisplay.html(currentSize);
    // }
    // else {
    //   if (currentStock > 0) {
    //     $sizeDisplay.html(currentSize + ' - Only ' + currentStock + ' Remaining');
    //   }
    //   else {
    //     $sizeDisplay.html(currentSize + ' - Sold Out');
    //   }
    // }
    $sizeDisplay.html(currentSize);
  }
  else {
    $sizeDisplay.html('');
  }
});

$('.quickview-colour-swatches').on('mouseover', '.quick-view-slim .colour-swatch', function () {
  $('#quickViewColorDisplay').data('original', $('#quickViewColorDisplay').text());
  $('#quickViewColorDisplay').text($(this).data('color-name'));
});

$('.quickview-colour-swatches').on('mouseout', '.quick-view-slim .colour-swatch', function () {
  $('#quickViewColorDisplay').text($('#quickViewColorDisplay').data('original'));
});

$('.quick-view-cancel').on('click', function(e) {
  e.preventDefault();

  $('#quickview').removeClass('active');
  $('body').removeClass('quickview-enabled');
  $('body').css('paddingRight', '');
});

$('.quick-view-close').on('click', function (e) {
  e.preventDefault();

  $('#quickview').removeClass('active');
  $('body').removeClass('quickview-enabled');
  $('body').css('paddingRight', '');
});

$('#quickview').on('click', '#AddToCart', function(e) {
  if ($('.product-size-wrap').hasClass('no-sizes')) {
    $('#quickview').removeClass('active');
    $('body').removeClass('quickview-enabled');
    $('body').css('paddingRight', '');
  } else {
    if ($('input[name=id]').is(':checked')) {
      $('#quickview').removeClass('active');
      $('body').removeClass('quickview-enabled');
      $('body').css('paddingRight', '');
    }
    else {
      e.preventDefault();
      $('.add-to-cart-text').hide();
      $('.add-to-cart-text--no-size').show();

      setTimeout(function () {
        $('.add-to-cart-text').show();
        $('.add-to-cart-text--no-size').hide();
      }, 2000);
    }
  }
});

$(document).mouseup(function (e) {
  if($('body').hasClass('quickview-enabled')) {
    var container = $("#quickview");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('#quickview').removeClass('active');
      $('body').removeClass('quickview-enabled');
      $('body').css('paddingRight', '');
    }
  }
});
